import { useEffect, useRef, useState } from "react";
import FishPhysicsCharacter from "./FishPhysicsCharacter";
import { makeFishPhysicsRig, updateFishPhysicsRig, type FishPhysicsRig } from "./marinePhysics";

export default function LandingFish() {
  const modelRef = useRef<FishPhysicsRig | null>(null);
  const [, renderFrame] = useState(0);
  if (!modelRef.current) modelRef.current = makeFishPhysicsRig();

  useEffect(() => {
    let frame = 0;
    let previousTime: number | null = null;
    const animate = (now: number) => {
      const model = modelRef.current;
      if (model) {
        const deltaSeconds = previousTime === null ? 1 / 60 : Math.min(0.06, Math.max(0, (now - previousTime) / 1000));
        updateFishPhysicsRig(model, { heading: 0, velocityRelativeToWater: { x: 34, y: 0 }, dt: deltaSeconds, reducedMotion: false });
        renderFrame((value) => value + 1);
      }
      previousTime = now;
      frame = window.requestAnimationFrame(animate);
    };
    frame = window.requestAnimationFrame(animate);
    return () => window.cancelAnimationFrame(frame);
  }, []);

  return <FishPhysicsCharacter model={modelRef.current} heading={0} />;
}
